import { Box } from "@material-ui/core";
import { ConsultantPipelineCardFragment } from "@graphql";
import { useLocale } from "@hooks";
import { ColumnDescription } from "../kanban-board/kanban-types";

type Props = {
  column: ColumnDescription<ConsultantPipelineCardFragment>;
  initialColumn?: ColumnDescription<ConsultantPipelineCardFragment>;
};

export function ConsultantPipelineColumnHeader({ column, initialColumn }: Props) {
  const { locale } = useLocale();

  let countText = `${column.cards.length}`;
  if (initialColumn && initialColumn.cards.length > column.cards.length) {
    countText += `/${initialColumn.cards.length}`;
  }

  return (
    <Box
      className="react-kanban-column-header"
      display="flex"
      justifyContent="space-between"
    >
      <span style={{ cursor: "pointer" }}>
        {locale.consultantPipelineBoardHeaders[column.title]}
      </span>
      <span style={{ whiteSpace: "nowrap" }}>{countText}</span>
    </Box>
  );
}
